import { configureStore } from '@reduxjs/toolkit';
import claimsReducer from './claimsSlice';
import authReducer from './authSlice';

export const store = configureStore({
  reducer: {
    claims: claimsReducer,
    auth: authReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch; 